















































import { Component, Vue } from "vue-property-decorator";

declare global {
  interface Window {
    referenzenArray: any;
  }
}

@Component
export default class Referenzen extends Vue {
  referenzenArray: any = [];
//   referenzenArray: any = [
//     {
//         "title": "Gebler Immobilien iOS-App",
//         "kategorie": "App-Entwicklung",
//         "tags": [
//             {
//                 "tags": "App-Entwicklung"
//             },
//             {
//                 "tags": "Swift"
//             },
//             {
//                 "tags": "Xcode"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/gebler-immobilien-ios-app",
//         "image": "/application/files/thumbnails/720/5516/6575/6450/iphone_entwicklung_gebler_immobilien.jpg",
//         "linkTitle": "App-Entwicklung Referenz Gebler Immobilien iOS-App",
//         "active": true
//     },
//     {
//         "title": "Eurotec",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "Concrete5"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/eurotec",
//         "image": "/application/files/thumbnails/720/4716/3972/7737/webseiten_relaunch_eurotec.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz Eurotec",
//         "active": true
//     },
//     {
//         "title": "Eurotec BIM-Produktkatalog",
//         "kategorie": "Webentwicklung",
//         "tags": [
//             {
//                 "tags": "Angular-App"
//             },
//             {
//                 "tags": "Webentwicklung"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/eurotec-bim-produktkatalog",
//         "image": "/application/files/thumbnails/720/7516/3969/2252/angular_bim.jpg",
//         "linkTitle": "Webentwicklung Referenz Eurotec BIM-Produktkatalog",
//         "active": true
//     },
//     {
//         "title": "Fichte Hagen",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "WordPress"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/fichte-hagen",
//         "image": "/application/files/thumbnails/720/1116/1882/5766/webseiten_relaunch_fichte_hagen.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz Fichte Hagen",
//         "active": true
//     },
//     {
//         "title": "Anker Schroeder",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "Concrete5"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/anker-schroeder",
//         "image": "/application/files/thumbnails/720/6416/1883/3414/webseiten_relaunch_anker_schroeder.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz Anker Schroeder",
//         "active": true
//     },
//     {
//         "title": "Büro für urbane Projekte",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "Concrete5"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/buero-fuer-urbane-projekte",
//         "image": "/application/files/thumbnails/720/9016/3963/9639/webseiten_relaunch_urbaneprojekte.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz Büro für urbane Projekte",
//         "active": true
//     },
//     {
//         "title": "jobcenter Hagen",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "Concrete5"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/jobcenter-hagen",
//         "image": "/application/files/thumbnails/720/7516/3964/3672/webseiten_relaunch_jobcenter_hagen.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz jobcenter Hagen",
//         "active": true
//     },
//     {
//         "title": "HSI Hermann Schwerter",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "Concrete5"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/hsi-hermann-schwerter",
//         "image": "/application/files/thumbnails/720/4316/3966/3356/webseiten_relaunch_hsi.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz HSI Hermann Schwerter",
//         "active": true
//     },
//     {
//         "title": "SafeTec",
//         "kategorie": "Online-Shop Erstellung",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Corporate Design"
//             },
//             {
//                 "tags": "WordPress"
//             },
//             {
//                 "tags": "Online-Shop"
//             },
//             {
//                 "tags": "WooCommerce"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/safetec",
//         "image": "/application/files/thumbnails/720/2016/3967/7492/online_shop_erstellung_mysafetec.jpg",
//         "linkTitle": "Online-Shop Erstellung Referenz SafeTec",
//         "active": true
//     },
//     {
//         "title": "KESS IT Consulting & Training",
//         "kategorie": "Webseiten Relaunch",
//         "tags": [
//             {
//                 "tags": "Webdesign"
//             },
//             {
//                 "tags": "Responsive Webdesign"
//             },
//             {
//                 "tags": "Webseiten Relaunch"
//             },
//             {
//                 "tags": "Onpage Optimierung"
//             },
//             {
//                 "tags": "SEO Betreuung"
//             },
//             {
//                 "tags": "Concrete5"
//             }
//         ],
//         "url": "https://www.ultrapixel.de/referenzen/kess-it-consulting-training",
//         "image": "/application/files/thumbnails/720/4316/3967/9076/webseitenerstellung_kess_it_consulting_training.jpg",
//         "linkTitle": "Webseiten Relaunch Referenz KESS IT Consulting & Training",
//         "active": true
//     }
// ]
  filter: any = [];

  mounted() {
    if (window.referenzenArray !== undefined)
      this.referenzenArray = window.referenzenArray;
    if (this.referenzenArray) this.createFilter(this.referenzenArray);
  }

  createFilter(referenzen: any) {
    for (const referenz of referenzen) {
      if (!this.filter.includes(referenz.kategorie))
        this.filter.push(referenz.kategorie);
    }
  }

  changeFilter(e: any) {
    for (const referenz of this.referenzenArray) {
      if (e.target.value === "Alle Leistungen") {
        referenz.active = true;
      } else {
        if (referenz.kategorie === e.target.value) {
          referenz.active = true;
        } else {
          referenz.active = false;
        }
      }
    }
  }
}
